import React from 'react';
import Header from '../../components/Header';
import StatusIpp from '../../components/StatusIpp';
import Filter from '../../components/Filter';
import Grid from '../../components/Grid';
import Footer from '../../components/Footer';
import { AuthIppProvider } from '../../contexts/authIpp';
import Details from '../../components/ButtonGridDatails';


import './index.scss';
import { Button } from '@material-ui/core';

const Dashboard: React.FC = () => {
  return (
    <>
      <Header />
      <div id="Container">
        <AuthIppProvider>
          <StatusIpp />
        </AuthIppProvider>
        <div id="Container-Dados">
          <Filter />
          <Grid />
          <Details messageErrorIpp='' />
          <Footer />
        </div>
      </div>
    </>
  );
};


export default Dashboard;
